export function getPersonalInfo (state) {
  return state.personalInfo
}
export function getLanguagesOptions (state) {
  return {
    max_selected: state.languages?.max_selected,
    min_selected: state.languages?.min_selected,
    selected: state.languages?.selected || []
  }
}
export function getStepStatus (state) {
  return state.stepStatus
}
export function getLanguages (state) {
  return state.languages?.languages || []
}
export function getLanguageLevels (state) {
  return state.languages?.levels || []
}
export function getGenders (state) {
  return state.personalInfoFetchedData?.genders || []
}
export function getCountries (state) {
  return state.personalInfoFetchedData?.zn_countries || []
}
export function getBirthDate (state) {
  return state.personalInfoFetchedData?.birthdate || {}
}
export function getTeachingCourses (state) {
  return state.teachingCourses || {}
}
export function getRouteNameSteps (state) {
  return state.routeNameSteps
}
export function getTeachingPriceFetchedData (state) {
  return state.teachingPriceFetchedData
}
export function getEducationDegrees (state) {
  return state.educationDegrees
}
export function getWorkExperiences (state) {
  return state.workExperiences
}
export function getCertificates (state) {
  return state.certificates
}
export function getProfilePicture (state) {
  return state.profilePicture
}
export function getTeacherAbout (state) {
  return state.teacherAbout
}
export function getIntroVideo (state) {
  return state.introVideo
}
export function getWorkTimeZone (state) {
  return state.workTime?.timezone
}
export function getWorkTimeWeekdays (state) {
  return state.workTime?.weekdays
}
export function getWorkTimeAvailableTime (state) {
  return state.workTime?.available_times
}
export function getTeacherDocuments (state) {
  return state.documents
}
export function getTeacherDocumentAttachments (state) {
  return state.documents?.teacher_document_attachments
}
export function getTrackingStatus (state) {
  return state.tracking?.status
}
export function getTrackingSteps (state) {
  return state.tracking?.steps
}
export function getPriceChart (state) {
  return state.priceChart
}
export function getTagline (state) {
  return state.tagline
}
export function getIntroduction (state) {
  return state.introduction
}
export function getJoinUs (state) {
  return state.join_us
}
